export default function dateStringToUTCDate(dateString)
{
	if(!dateString)
	{
		return null;
	}
	// date string should be in the format "YY-MM-DD HH:MM:SS" and UTC timezone
	const dateParts = dateString.split(/[ :-]/);

	// because month is 0 indexed and day and year are 1 indexed.
	dateParts[1] --;

	return new Date(Date.UTC.apply(Date,dateParts) || null);
}
